<template>
  <div class="card border-secondary">
    <div class="card-body">
      <div class="form-row align-items-start">
        <label for="codigo-promocional small">Tem algum código promocional?</label>
        <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
          <input type="text" v-model="codigo" @input="codigoPromocional" id="codigo-promocional" class="form-control">
          <div class="avisoDanger text-left mt-1" v-if="!retorno.sucesso">{{ retorno.mensagem }}</div>
        </div>
        <div class="col-4 col-lg-4 col-md-12 col-sm-12 col-12 mt-1">
          <button @click="aplicarCodigoPromocional" :disabled="flagsDeControle.carregandoDados.status || itens.length === 0" class="btn btn-sm btn-azul">Aplicar Cupom</button>
        </div>
      </div>
      <div class="row" v-if="this.cupomData.length > 0">
        <div class="col-12 avisoSucesso">
          Seu cupom do codigo: <b>{{ codigoSelecionado }}</b> foi aplicado com sucesso.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mensagens from '@/util/mensagens'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'codigo-promocional',
  components: {
  },
  props: {
  },
  computed: {
    ...mapState('carrinho', ['itens', 'cupomData'])
  },
  data: () => {
    return {
      codigo: null,
      codigoSelecionado: null,
      cupomSelecionado: null,
      retorno: {
        sucesso: false,
        listaDeErros: {},
        mensagem: '',
        listaDados: {}
      },
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      }
    }
  },
  mounted () {
    if (this.cupomData.length > 0) {
      this.codigoSelecionado = JSON.parse(this.cupomData).codigo
    }
  },
  watch: {
    cupomData () {
      if (this.cupomData.length === undefined) {
        this.codigoSelecionado = null
        this.cupomSelecionado = null
        this.codigo = null
      }
    }
  },
  methods: {
    ...mapActions('carrinho', [
      'ActionDefinirCupomDataDoCarrinho',
      'ActionLimparCupomDataDoCarrinho'
    ]),
    async obterCupom (cupom) {
      this.ActionLimparCupomDataDoCarrinho()
      this.$parent.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.axios.get(`/manager/conta/cupom/${cupom}`)
        this.retorno.sucesso = resposta.data.retorno.sucesso

        if (this.retorno.sucesso) {
          this.cupomSelecionado = resposta.data.retorno.dados
          if (this.cupomSelecionado.plano !== null) {
            let temItemCupom = false
            for (let item of this.itens) {
              if (item.produto.plano.id === this.cupomSelecionado.plano) {
                temItemCupom = true
                break
              }
            }

            if (!temItemCupom) {
              this.retorno.sucesso = false
              this.retorno.mensagem = 'Cupom não é válido para os itens do carrinho.'
              this.$parent.definirFlagCarregandoDados(false, '')
              return
            }
          }
          this.ActionDefinirCupomDataDoCarrinho(JSON.stringify((resposta.data.retorno.dados)))
          if (this.cupomData.length > 0) {
            this.codigoSelecionado = JSON.parse(this.cupomData).codigo
          }
          this.$emit('atualizarPrecos')
        } else {
          this.codigoSelecionado = null
          this.cupomSelecionado = null
          this.codigo = null
          this.retorno.listaDeErros = resposta.data.retorno.listaDeErros
        }
        this.retorno.mensagem = resposta.data.retorno.mensagem
        this.$parent.definirFlagCarregandoDados(false, '')
      } catch (e) {
        this.retorno.sucesso = false
        this.retorno.mensagem = 'Cupom não encontrado ou inválido.'
        this.$parent.definirFlagCarregandoDados(false, '')
      }
    },
    aplicarCodigoPromocional () {
      if (!this.codigo) {
        this.retorno.sucesso = false

        if (this.cupomData.length > 0) {
          this.retorno.mensagem = 'Cupom removido.'
          this.ActionLimparCupomDataDoCarrinho()
          this.$emit('atualizarPrecos')
        } else {
          this.retorno.mensagem = 'Informe um código promocional.'
        }
        return
      }
      this.obterCupom(this.codigo)
    },
    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },
    codigoPromocional () {
      this.codigo = this.codigo.toUpperCase()
    }
  }
}
</script>

<style>
  .avisoSucesso{
    color: #28a745;
  }
</style>
